export default "__VITE_ASSET__iCBaKTN7__"